// extracted by mini-css-extract-plugin
module.exports = {"navs":"bn_cM","dividerAnimation":"bn_p","nav":"bn_cN","title":"bn_S","subTitle":"bn_bN","hasBottomIndent":"bn_cP","header":"bn_bn"};